/**
 * 官方音乐直连（预留）：每个 profile 独立 baseURL、API Key、路径。
 */
import { submitVolcSunoMusicTask, pollVolcSunoMusicTask } from './volc-suno-music'

export function submitOfficialMusic(profileId, params) {
  if (profileId === 'volc-suno-music') {
    return submitVolcSunoMusicTask(params)
  }
  return Promise.reject(new Error('Official music profile not implemented: ' + profileId))
}

export function pollOfficialMusic(profileId, taskId, callback, interval) {
  if (profileId === 'volc-suno-music') {
    return pollVolcSunoMusicTask(taskId, callback, interval)
  }
  throw new Error('Official music profile not implemented: ' + profileId)
}
